export function XGGPPillUnit({ value = null }) {
  return (
    <span className="pointer-events-none flex h-14 w-28 flex-none flex-row items-center justify-between space-x-2 rounded-full bg-black px-4 py-1.5 text-xs text-white md:w-40 md:px-6">
      <svg
        fill="none"
        height="23"
        viewBox="0 0 23 23"
        width="23"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.30971 2.14697C9.5251 0.290566 13.4866 0.290566 16.702 2.14697C19.9174 4.00338 21.8982 7.43416 21.8982 11.147C21.8982 14.8598 19.9174 18.2906 16.702 20.147C13.4866 22.0034 9.5251 22.0034 6.30971 20.147C3.09432 18.2906 1.11355 14.8598 1.11355 11.147C1.11355 7.43416 3.09432 4.00338 6.30971 2.14697Z"
          fill="#00C2FF"
        />
        <path
          d="M11.4595 5.70605V7.69834M11.4595 16.3316V14.3393"
          stroke="black"
          strokeLinecap="round"
          strokeWidth="1.66024"
        />
        <path
          d="M16.1902 8.29443L14.1159 9.49205M6.87515 13.6725L9.13515 12.3677"
          stroke="black"
          strokeLinecap="round"
          strokeWidth="1.66024"
        />
        <path
          d="M16.1902 13.6729L14.1159 12.4752M6.87515 8.29481L8.8031 9.40792"
          stroke="black"
          strokeLinecap="round"
          strokeWidth="1.66024"
        />
        <circle
          cx="11.5486"
          cy="10.8391"
          r="2.7224"
          stroke="black"
          strokeLinecap="round"
          strokeWidth="1.66024"
        />
        <circle cx="8.05821" cy="5.00425" fill="black" r="0.428571" />
        <circle cx="8.05821" cy="17.1576" fill="black" r="0.428571" />
        <circle cx="15.1632" cy="5.00425" fill="black" r="0.428571" />
        <circle cx="18.5289" cy="10.9872" fill="black" r="0.428571" />
        <circle cx="4.50572" cy="10.9872" fill="black" r="0.428571" />
        <circle cx="15.1632" cy="17.1576" fill="black" r="0.428571" />
      </svg>

      <div className="text-base font-bold md:text-lg">xGGP</div>
      {value ? <div>{(Math.round(value * 100) / 100).toFixed(2).replace(/\.?0+$/, '')}</div> : null}
    </span>
  )
}
